import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageBarStore, Modal, SOFTLINE_FEATURE_MESSAGE_BAR, UiCoreModule } from '@softline/ui-core';
import { Store } from '@softline/core';
import { LighterMaterial, MaterialService } from '../../services/material.service';
import { Material } from '../../types/material';

@Component({
    selector: 'soft-lighter-dialog',
    imports: [CommonModule, UiCoreModule],
    templateUrl: './lighter-dialog.component.html',
    styleUrl: './lighter-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LighterDialogComponent implements Modal<any>, OnInit {
  close!: (result: any) => void;
  id!: number;
  gewicht!: number;

  readonly loading = signal<boolean>(false);
  readonly lighterMaterials = signal<LighterMaterial[]>([]);
  readonly selectedMaterial = signal<LighterMaterial | null>(null);

  constructor(private service: MaterialService, private store: Store) {}

  async ngOnInit(): Promise<void> {
    this.loading.set(true);

    try {
      const result = await this.service.getLighterMaterials(this.id, this.gewicht);
      this.lighterMaterials.set(result);

      if (result?.length >= 1) {
        this.selectedMaterial.set(result[0]);
      }

      this.loading.set(false);
    } catch (e) {
      this.loading.set(false);
      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.error,
          {
        title: 'Fehler',
        message: 'Materialien konnten nicht geladen werden!'
        }
      )
    }
  }

  registerCloseHandler(handler: (result: any) => void) {
    this.close = handler;
  }
}
